<template>
  <div class="page-wrapper">
    <div>
      <search-list @findData="findData" :selectedData="selectedData" @postBuildingList="setBuildingList"></search-list>
      <div class="">
        <div class="content">
          <div id="floor-list" v-show="false">
            <ul>
              <li v-for="(f,index) in 4" :key="index">{{`F${f}`}}</li>
            </ul>
          </div>
          <Tabs :animated="false" class="tab" id="house-tab" @on-click="changeRentType">
            <TabPane label="整租">
              <Spin size="large" v-if="showSpin" class="spin"></Spin>
              <div class="card-wrap">
                <cards-list v-for="(item,i) in subFloorList" :type="'zz'" :cityCode="searchData.cityCode"
                            :stockData="item" :i="i" :key="'zz'+i"
                            :projectFid="searchData.projectFid"
                            @personbook="personbook"
                ></cards-list>
                <div v-if ="!hasData(subFloorList) && !showSpin" class="no-data">暂无数据</div>
              </div>
            </TabPane>
            <TabPane label="合租">
              <Spin size="large" v-if="showSpin" class="spin"></Spin>
              <div class="card-wrap">
                <cards-list v-if="subFloorList.length > 0" v-for="(item,i) in subFloorList" :type="'hz'"
                            :cityCode="searchData.cityCode"
                            :stockData="item" :i="i" :key="'hz'+i"
                            :projectFid="searchData.projectFid"
                            :rentType=1
                            @personbook="personbook"
                ></cards-list>
                <div v-if ="!hasData(subFloorList) && !showSpin" class="no-data">暂无数据</div>
              </div>
            </TabPane>
            <div slot="extra">
              <Button type="primary" @click="businessBook" size="small" style="margin-right: 10px">企业预订</Button>

              <Button type="primary" @click="businessSign" size="small" v-p="{api:'enterprisecontract/roomCanRent'}">
                企业签约
              </Button>
              <span style="padding-left:20px">{{stockNum}}间/床位</span>
            </div>
          </Tabs>
        </div>
        <BusinessSignModal :n="signKey" :closeKey="closePickStockKey"
                           :rentType="searchData.stockRentType"
                           :projectFid="searchData.projectFid"
                           :buildingList="buildingList" @save="goCreatContract"></BusinessSignModal>

        <business-book-select :n="bookKey" :closeKey="closePickStockKey2"
                              :rentType="searchData.stockRentType"
                              :projectFid="searchData.projectFid"
                              :buildingList="buildingList"
                              @update="getOutHouseList(searchData)"
        ></business-book-select>


        <create-business-contract :projectFid="searchData.projectFid" :n="createKey" :roomsCount="roomsCount"
                                  :roomIds="roomIds" :createContractData="createContractData"
                                  @close-modal="closePickStockModal"
        ></create-business-contract>

        <person-book :n="pbN" :data="personbookData" @update="getOutHouseList(searchData)"></person-book>



      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {addClass, removeClass} from '@/utils/tool'
  import CardsList from './components/CardsList';
  import SearchList from './components/SearchList';
  import BusinessSignModal from './components/BusinessSignModal';
  import CreateBusinessContract from './components/CreateBusinessContract'
  import {getSelectedData, getOutHouseList} from "api/outHouse"
  import {buildInfo, getHouseType} from "api/house"

  import PersonBook from './components/PersonBook'
  import BusinessBookSelect from './components/BusinessBookSelect.vue'


  export default {
    name: 'cardsview',
    created() {
      this.initData()
    },
    activated() {
      if (this.$route.params.projectFid) {
        this.searchData.projectFid = this.$route.params.projectFid
      }
    },
    components: {
      SearchList,
      CardsList,
      BusinessSignModal,
      CreateBusinessContract,
      PersonBook,
      BusinessBookSelect,
    },
    data() {
      return {
        personbookData:null,
        closePickStockKey2: 0,

        bookKey: 0,
        pbN: 0,
        showSpin: false,
        loading: false,
        closePickStockKey: 0,
        signKey: 0,
        createKey: 0,
        selectedData: null,
        stockNum: 0,
        roomsCount: 0,
        roomIds: '',
        createContractData: null,
        subFloorList: [],
        buildingList: [],
        searchData: {
          cityCode: '',
          houseBuildingFid: '',
          houseDecorationStyle: '',
          houseFloorNumber: '',
          houseTypeFid: '',
          projectFid: '',
          stockNumber: '',
          stockRentDate: '',
          stockRentType: 0, // 0 整租，1 合租
          stockStatus: '',
          stockType: '',
          stockVacancyDay: '',
          stockIsOrder: '',
          limitLabel:''
        }
      };
    },
    methods: {

      personbook(data) {
        this.personbookData=data
        this.pbN++

      },
      changeRentType(name) {
        this.searchData.stockRentType = name;
        this.getOutHouseList(this.searchData)
      },
      hasData(data) {
        if (data.length === 0) return false;

        return data.some(item => {
          return item.subStockList.length > 0
        })
      },
      closePickStockModal() {
        this.closePickStockKey++
      },
      findData(searchData) {
        // this.searchData = searchData
        for (const key in this.searchData) {
          if (key === 'stockRentType') continue;
          this.searchData[key] = searchData[key]
        }
        this.getOutHouseList(this.searchData)
      },
      businessSign() {
        this.signKey++
      },
      businessBook() {
        this.bookKey++

      },
      setBuildingList(val) {
        this.buildingList = val
      },
      initData() {
        const projectFid = '';
        const houseBuildingFid = '';
        getSelectedData().then(res => {
          this.selectedData = res.data;
          this.searchData.cityCode = res.data.openCityEnums[0].value;
          buildInfo(this.searchData.cityCode).then(res => {
            if (res.data && res.data.length > 0) {
              this.searchData.projectFid = res.data[0].value;
              if (res.data[0].children === [] || !res.data[0].children === []) {
                reject('未获取到楼栋信息')
              }
              this.searchData.houseBuildingFid = res.data[0].children[0].value;
              //this.searchData.houseBuildingFid = '02'
              //stockStatus:0 默认查询待租中,0是写死的,对应后台待租中枚举值
              this.getOutHouseList({
                houseBuildingFid: this.searchData.houseBuildingFid,
                stockRentType: 0,
                stockStatus: 0
              })
            }
            this.showSpin = false
          }).catch(err => {
            console.log(err)
          }).finally(() => {
            this.showSpin = false

          })
        })
      },
      // goBook(data) {
      //   console.log(data)
      //

      // },
      goCreatContract(data) {
        this.roomsCount = data.count;
        this.roomIds = data.roomIds;
        this.createContractData = data.resData;
        this.createKey++
        //console.log(this.createKey)

      },

      getOutHouseList(params) {
        this.showSpin = true;
        getOutHouseList(params).then(res => {
          this.stockNum = res.data.stockNum;
          this.subFloorList = res.data.subFloorList;
          this.showSpin = false
          // console.log(res.data)
        }).finally(() => {
          this.showSpin = false

        })
      }
    }
  }
</script>

<style lang="css" scoped>

  .wrapper {
    display: flex;
    overflow: auto;
    padding: 26px 24px 26px;
  }

  .filter-box {
    width: 148px;
    height: 200px;
    border: 1px solid #DDDEE1;
    border-radius: 2px;
  }

  .content {
    flex: 1;
    /* padding-left: 15px; */
  }

  .tab {
    margin-top: 16px;
    border: 1px solid #DDDEE1;
    border-radius: 2px;
    width: 100%;
  }

  #floor-list {
    padding-right: 8px;
  }

  #floor-list li {
    border: 1px solid #DDDEE1;
    border-bottom-width: 0px;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
  }

  #floor-list li:last-child {
    border-bottom: 1px solid #DDDEE1;
  }

  #floor-list {
    position: absolute;
    margin-top: 16px;
    left: 8px;
  }

  .no-data {
    text-align: center;
    padding: 18px;
  }

  .card-wrap {
    min-height: 100px;
  }

  .spin {
    top: auto;
    height: auto;
  }
</style>
